module.exports = __webpack_public_path__ + "media/images/wedding/thumb/19-ec3d64c62a52736a3f3565d48232ddd9.jpg";